
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-product-comparison",
      function () {
        return require("private-next-pages/blog/mui-product-comparison.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-product-comparison"])
      });
    }
  